import React from 'react'

import PrimaryButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/primaryButton/PrimaryButton'

import styles from './requestPayment.module.scss'

const ClientIneligibleModal = ({ closeFunc }: any) => {
  return (
    <div data-test-id='requestpayment-clientIneligibleModal' className={styles['modal-content']}>
      <h2 className={styles['main-header']}>Your client may not be eligible</h2>
      <p>
        According to our records, this client does not seem to be eligible. Please check their details or have them
        reach out to their benefits team.
      </p>
      <p>
        Feel free to reach out to <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a> for additional
        assistance.
      </p>
      <div className={styles['dismiss-button']}>
        <PrimaryButton onClick={closeFunc}>Return to form</PrimaryButton>
      </div>
    </div>
  )
}

export default ClientIneligibleModal
